import { Layout } from "antd"
import Head from "next/head"
import styled from "styled-components"
import {
  Banner,
  CompanyDetailSection,
  ContactUsComponent,
  Footer,
  MultipleSectorComponent,
  TechCompany,
} from "../components"
import { TechToolSectionComponent } from "../components/organisms/TechTool"
import { SuccessStories } from "../components/organisms/SuccessStories"
import { MediumSection } from "../components/organisms/MediumSection"
import { LocationSection } from "../components/organisms/LocationSection"

const StyledLayout = styled(Layout)`
  position: sticky;
  z-index: 2;
`

const Home = () => {
  return (
    <>
      <Head>
        <title>{"Home | TeamNepal "}</title>
      </Head>
      <Banner />
      <StyledLayout>
        <TechCompany />
        <MultipleSectorComponent />
        <TechToolSectionComponent />
        <ContactUsComponent isLP={true} />
        <CompanyDetailSection />
        <SuccessStories />
        <MediumSection />
        <LocationSection />
        <Footer />
      </StyledLayout>
    </>
  )
}

export default Home
